// 开发环境域名
// https://php-b2csaas.yixiangonline.com

// const host_development = 'https://shopq43z12ci.yixiangonline.com'

// 线上环境域名
// const host_development = "https://admin.nrsaas.nrrhy.com";

const host_development = 'http://192.168.0.250:3012'

export default {
    // 版本
    version: '3.4.0',
    baseURL: process.env.NODE_ENV == 'production' ? '' : host_development,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
